/* ==========================================================================
   Muicoo Scoop theme — interactions
   ========================================================================== */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  /* Active currency: prefer the Shopify global, then fall back to the value
     the theme renders onto <html data-shop-currency>. Without the fallback,
     prices would flip to USD whenever Shopify.currency is unavailable. */
  var activeCurrency = function () {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return window.Shopify.currency.active;
    }
    return document.documentElement.getAttribute('data-shop-currency') || 'USD';
  };

  var money = function (cents) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: activeCurrency()
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  };

  /* ----------------------------------------------------------------------
     Announcement ticker
     ---------------------------------------------------------------------- */
  function initTicker(bar) {
    var key = bar.getAttribute('data-storage-key');
    if (key) {
      try {
        if (sessionStorage.getItem(key) === 'closed') { bar.hidden = true; }
      } catch (e) {}
    }

    var closeBtn = $('[data-campaign-close]', bar);
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        bar.hidden = true;
        if (key) { try { sessionStorage.setItem(key, 'closed'); } catch (e) {} }
      });
    }

    if (bar.getAttribute('data-type') === 'slide') {
      var items = $$('.campaign-bar__item', bar);
      if (items.length) {
        var idx = 0;
        items.forEach(function (it, i) { if (i === 0) it.classList.add('is-active'); });
        var interval = (parseFloat(bar.getAttribute('data-slide-speed')) || 4) * 1000;
        setInterval(function () {
          items[idx].classList.remove('is-active');
          idx = (idx + 1) % items.length;
          items[idx].classList.add('is-active');
        }, interval);
      }
    }
  }

  /* ----------------------------------------------------------------------
     Currency switcher dropdown
     ---------------------------------------------------------------------- */
  function initCurrency(root) {
    var toggle = $('[data-currency-toggle]', root);
    if (!toggle) return;
    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = root.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) {
        root.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ----------------------------------------------------------------------
     Drawers / overlay / mobile nav
     ---------------------------------------------------------------------- */
  var overlay = $('[data-overlay]');

  function closeAll() {
    $$('.em-drawer.is-open, .mobile-nav.is-open').forEach(function (el) { el.classList.remove('is-open'); });
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function openPanel(el) {
    if (!el) return;
    el.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function bindPanels() {
    var map = [
      ['[data-open-cart]', '[data-cart-drawer]'],
      ['[data-open-search]', '[data-search-drawer]'],
      ['[data-open-mobile-nav]', '[data-mobile-nav]']
    ];
    map.forEach(function (pair) {
      $$(pair[0]).forEach(function (btn) {
        btn.addEventListener('click', function () { openPanel($(pair[1])); });
      });
    });

    $$('[data-close-drawer], [data-close-mobile-nav]').forEach(function (btn) {
      btn.addEventListener('click', closeAll);
    });
    if (overlay) overlay.addEventListener('click', closeAll);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  }

  /* ----------------------------------------------------------------------
     Accordion
     ---------------------------------------------------------------------- */
  function bindAccordions() {
    $$('[data-accordion-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.product-accordion__item');
        if (!item) return;
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ----------------------------------------------------------------------
     Short description "Show more"
     ---------------------------------------------------------------------- */
  function bindShowMore() {
    $$('[data-show-more]').forEach(function (btn) {
      var target = $('[data-short-description]');
      if (!target) return;
      // Hide the toggle when content is not actually overflowing.
      if (target.scrollHeight <= target.clientHeight + 4) {
        target.classList.remove('short-description--clamped');
        btn.style.display = 'none';
        return;
      }
      btn.addEventListener('click', function () {
        var clamped = target.classList.toggle('short-description--clamped');
        btn.textContent = clamped ? btn.getAttribute('data-more-text') : btn.getAttribute('data-less-text');
      });
    });
  }

  /* ----------------------------------------------------------------------
     Product gallery
     ---------------------------------------------------------------------- */
  function initGallery(root) {
    var track = $('[data-gallery-track]', root);
    var slides = $$('[data-gallery-slide]', root);
    var thumbs = $$('[data-gallery-thumb]', root);
    if (!track || !slides.length) return;

    var index = 0;

    function pauseVideos() {
      $$('video', root).forEach(function (v) { if (!v.paused) v.pause(); });
    }

    function go(i) {
      index = Math.max(0, Math.min(i, slides.length - 1));
      track.style.transform = 'translateX(' + (-100 * index) + '%)';
      thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === index); });
      var prev = $('[data-gallery-prev]', root);
      var next = $('[data-gallery-next]', root);
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
      pauseVideos();
      // Keep the active thumbnail in view.
      if (thumbs[index] && thumbs[index].scrollIntoView) {
        thumbs[index].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
    }

    thumbs.forEach(function (t, ti) {
      t.addEventListener('click', function () { go(ti); });
    });
    var prevBtn = $('[data-gallery-prev]', root);
    var nextBtn = $('[data-gallery-next]', root);
    if (prevBtn) prevBtn.addEventListener('click', function () { go(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(index + 1); });

    // Keyboard
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') go(index - 1);
      if (e.key === 'ArrowRight') go(index + 1);
    });

    // Touch swipe
    var startX = 0, startY = 0, dragging = false;
    track.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX; startY = e.touches[0].clientY; dragging = true;
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (!dragging) return;
      dragging = false;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) { go(dx < 0 ? index + 1 : index - 1); }
    });

    // Zoom / lightbox
    var zoom = $('[data-gallery-zoom]', root);
    if (zoom) {
      zoom.addEventListener('click', function () {
        var img = slides[index].querySelector('img');
        if (img) openLightbox(img.getAttribute('data-full') || img.src, 'image', galleryUrls(), index);
      });
    }
    slides.forEach(function (s, si) {
      var img = s.querySelector('img');
      if (!img) return;
      img.style.cursor = 'zoom-in';
      img.addEventListener('click', function () {
        openLightbox(img.getAttribute('data-full') || img.src, 'image', galleryUrls(), si);
      });
    });

    function galleryUrls() {
      return slides.map(function (s) {
        var im = s.querySelector('img');
        return im ? { src: im.getAttribute('data-full') || im.src, type: 'image' } : null;
      }).filter(Boolean);
    }

    // Variant image sync
    root.addEventListener('em:variant:image', function (e) {
      var target = e.detail && e.detail.mediaId;
      if (!target) return;
      var found = slides.findIndex(function (s) {
        var im = s.querySelector('img');
        return im && im.src.indexOf(target) !== -1;
      });
      if (found > -1) go(found);
    });

    go(0);
  }

  /* ----------------------------------------------------------------------
     Lightbox
     ---------------------------------------------------------------------- */
  var lbState = { list: [], i: 0 };

  function openLightbox(src, type, list, startIndex) {
    var lb = $('[data-lightbox-root]');
    if (!lb) return;
    lbState.list = list && list.length ? list : [{ src: src, type: type }];
    lbState.i = typeof startIndex === 'number' ? startIndex : 0;
    renderLightbox();
    lb.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function renderLightbox() {
    var stage = $('[data-lightbox-stage]');
    if (!stage) return;
    var item = lbState.list[lbState.i];
    if (!item) return;
    stage.innerHTML = '';
    var el;
    if (item.type === 'video') {
      el = document.createElement('video');
      el.src = item.src;
      el.controls = true;
      el.autoplay = true;
      el.playsInline = true;
    } else {
      el = document.createElement('img');
      el.src = item.src;
      el.alt = '';
    }
    stage.appendChild(el);
    var nav = $$('[data-lightbox-nav]');
    nav.forEach(function (n) { n.style.display = lbState.list.length > 1 ? '' : 'none'; });
  }

  function bindLightbox() {
    var lb = $('[data-lightbox-root]');
    if (!lb) return;

    function close() {
      lb.classList.remove('is-open');
      document.body.style.overflow = '';
      var stage = $('[data-lightbox-stage]');
      if (stage) stage.innerHTML = '';
    }

    $$('[data-lightbox-close]').forEach(function (b) { b.addEventListener('click', close); });
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') step(-1);
      if (e.key === 'ArrowRight') step(1);
    });
    $$('[data-lightbox-nav]').forEach(function (b) {
      b.addEventListener('click', function () { step(b.getAttribute('data-lightbox-nav') === 'next' ? 1 : -1); });
    });

    function step(d) {
      lbState.i = (lbState.i + d + lbState.list.length) % lbState.list.length;
      renderLightbox();
    }

    // Review media opens in the lightbox
    document.addEventListener('click', function (e) {
      var link = e.target.closest ? e.target.closest('[data-lightbox]') : null;
      if (!link) return;
      e.preventDefault();
      var wrap = link.closest('.review-media');
      var list = wrap ? $$('[data-lightbox]', wrap).map(function (a) {
        return { src: a.getAttribute('href'), type: a.getAttribute('data-lightbox') };
      }) : [];
      var idx = wrap ? $$('[data-lightbox]', wrap).indexOf(link) : 0;
      openLightbox(link.getAttribute('href'), link.getAttribute('data-lightbox'), list, idx);
    });
  }

  /* ----------------------------------------------------------------------
     Variant picker + quantity + add to cart
     ---------------------------------------------------------------------- */
  function initProductForm(section) {
    var jsonEl = $('[data-product-json]', section) || $('[data-product-json]');
    var product = null;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    if (!product) return;

    var form = $('form[action*="/cart/add"]', section) || $('.product-form', section);
    var idInput = $('[data-variant-id]', section);
    var priceEl = $('[data-price]', section);
    var compareEl = $('[data-compare-price]', section);
    var saveEl = $('[data-save-badge]', section);
    var atcBtn = $('[data-add-to-cart]', section);
    var atcText = $('[data-atc-text]', section);
    var atcPrice = $('[data-atc-price]', section);
    var stockBadge = $('[data-stock-badge]', section);
    var gallery = $('[data-gallery]', section);

    function selectedOptions() {
      return $$('[data-option-position]', section)
        .filter(function (el) { return el.tagName === 'UL'; })
        .map(function (ul) {
          var chosen = $('.is-selected', ul);
          return chosen ? chosen.getAttribute('data-value') : null;
        });
    }

    function findVariant(opts) {
      return product.variants.find(function (v) {
        return opts.every(function (o, i) { return !o || v.options[i] === o; });
      });
    }

    function availabilityFor(position, value) {
      var opts = selectedOptions();
      opts[position - 1] = value;
      return product.variants.some(function (v) {
        return v.available && opts.every(function (o, i) {
          return i === position - 1 ? v.options[i] === value : (!o || v.options[i] === o);
        });
      });
    }

    function refreshAvailability() {
      $$('ul[data-option-position]', section).forEach(function (ul) {
        var pos = parseInt(ul.getAttribute('data-option-position'), 10);
        $$('.wcboost-variation-swatches__item', ul).forEach(function (li) {
          var val = li.getAttribute('data-value');
          li.classList.toggle('is-unavailable', !availabilityFor(pos, val));
        });
      });
    }

    function update() {
      var variant = findVariant(selectedOptions());
      if (!variant) {
        if (atcBtn) { atcBtn.disabled = true; }
        if (atcText) atcText.textContent = 'Unavailable';
        return;
      }

      if (idInput) idInput.value = variant.id;

      // URL sync
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}

      if (priceEl) priceEl.innerHTML = money(variant.price);
      if (compareEl) {
        if (variant.compare_at_price > variant.price) {
          compareEl.innerHTML = money(variant.compare_at_price);
          compareEl.style.display = '';
          if (saveEl) {
            saveEl.style.display = '';
            saveEl.textContent = 'Save ' + money(variant.compare_at_price - variant.price);
          }
        } else {
          compareEl.style.display = 'none';
          if (saveEl) saveEl.style.display = 'none';
        }
      }
      if (atcPrice) atcPrice.textContent = money(variant.price);

      if (atcBtn) {
        atcBtn.disabled = !variant.available;
        if (atcText) {
          atcText.textContent = variant.available
            ? (atcBtn.getAttribute('data-add-label') || atcText.getAttribute('data-default') || atcText.textContent)
            : 'Sold out';
        }
      }
      if (atcText && variant.available && !atcText.getAttribute('data-default')) {
        atcText.setAttribute('data-default', atcText.textContent);
      }

      if (stockBadge) {
        stockBadge.classList.toggle('product-stock--in', variant.available);
        stockBadge.classList.toggle('product-stock--out', !variant.available);
      }

      if (variant.featured_image && gallery) {
        var name = variant.featured_image.src.split('/').pop().split('?')[0].split('.')[0];
        gallery.dispatchEvent(new CustomEvent('em:variant:image', { detail: { mediaId: name } }));
      }

      refreshAvailability();
    }

    // Swatch clicks
    $$('[data-option-value]', section).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var li = btn.closest('.wcboost-variation-swatches__item');
        var ul = btn.closest('ul');
        if (!li || !ul) return;
        $$('.wcboost-variation-swatches__item', ul).forEach(function (x) {
          x.classList.remove('is-selected');
          var b = $('button', x);
          if (b) b.setAttribute('aria-checked', 'false');
        });
        li.classList.add('is-selected');
        btn.setAttribute('aria-checked', 'true');
        var pos = ul.getAttribute('data-option-position');
        var label = $('[data-selected-value="' + pos + '"]', section);
        if (label) label.textContent = btn.getAttribute('data-option-value');
        update();
      });
    });

    // Quantity
    var qty = $('[data-qty-input]', section);
    var minus = $('[data-qty-minus]', section);
    var plus = $('[data-qty-plus]', section);
    if (qty) {
      if (minus) minus.addEventListener('click', function () {
        qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1);
      });
      if (plus) plus.addEventListener('click', function () {
        qty.value = (parseInt(qty.value, 10) || 1) + 1;
      });
    }

    // AJAX add to cart
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!atcBtn || atcBtn.disabled) return;
        atcBtn.classList.add('is-loading');

        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: idInput ? idInput.value : null, quantity: qty ? parseInt(qty.value, 10) || 1 : 1 }]
          })
        })
          .then(function (r) { return r.json(); })
          .then(function () { return refreshCart(); })
          .then(function () { openPanel($('[data-cart-drawer]')); })
          .catch(function () { form.submit(); })
          .finally(function () { atcBtn.classList.remove('is-loading'); });
      });
    }

    refreshAvailability();
  }

  /* ----------------------------------------------------------------------
     Cart drawer contents
     ---------------------------------------------------------------------- */
  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        var body = $('[data-cart-body]');
        var foot = $('[data-cart-foot]');
        if (!body) return cart;

        if (!cart.items.length) {
          body.innerHTML =
            '<div class="em-drawer__empty"><h4>Your cart is empty</h4>' +
            '<p>You may check out all the available products and buy some in the shop</p>' +
            '<p style="margin-top:18px"><a class="em-button" href="/collections/all">Return to shop</a></p></div>';
          if (foot) foot.style.display = 'none';
          return cart;
        }

        body.innerHTML = cart.items.map(function (it) {
          return '<div class="cart-line">' +
            (it.image ? '<img src="' + it.image + '" alt="">' : '') +
            '<div><div class="cart-line__title">' + it.product_title + '</div>' +
            (it.variant_title ? '<div class="cart-line__variant">' + it.variant_title + '</div>' : '') +
            '<div class="cart-line__price">' + it.quantity + ' × ' + money(it.final_price) + '</div></div></div>';
        }).join('');

        if (foot) {
          foot.style.display = '';
          var total = $('[data-cart-total]', foot);
          if (total) total.textContent = money(cart.total_price);
        }
        return cart;
      })
      .catch(function () {});
  }

  /* ----------------------------------------------------------------------
     Reviews: load more + write-review modal
     ---------------------------------------------------------------------- */
  function bindReviews() {
    var btn = $('[data-load-more-reviews]');
    var list = $('[data-review-list]');
    if (btn && list) {
      var step = parseInt(list.getAttribute('data-step'), 10) || 8;
      btn.addEventListener('click', function () {
        var hidden = $$('li.review[hidden]', list);
        if (!hidden.length) return;
        btn.textContent = btn.getAttribute('data-loading-label');
        btn.disabled = true;
        // Small delay so the loading state is visible, matching the original.
        setTimeout(function () {
          hidden.slice(0, step).forEach(function (li) { li.hidden = false; });
          var left = $$('li.review[hidden]', list).length;
          btn.disabled = false;
          btn.textContent = btn.getAttribute('data-label');
          if (!left) { btn.parentNode.style.display = 'none'; }
        }, 350);
      });
    }

    var modal = $('[data-review-modal]');
    if (modal) {
      $$('[data-open-review-modal]').forEach(function (b) {
        b.addEventListener('click', function () {
          modal.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        });
      });
      function closeModal() {
        modal.classList.remove('is-open');
        document.body.style.overflow = '';
      }
      $$('[data-close-review-modal]').forEach(function (b) { b.addEventListener('click', closeModal); });
      modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
      });

      var stars = $$('[data-star]', modal);
      var chosen = 0;
      stars.forEach(function (s) {
        s.addEventListener('click', function () {
          chosen = parseInt(s.getAttribute('data-star'), 10);
          stars.forEach(function (x, xi) { x.classList.toggle('is-on', xi < chosen); });
        });
      });

      var form = $('[data-review-form]', modal);
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var name = form.querySelector('[name="name"]').value;
          var email = form.querySelector('[name="email"]').value;
          var body = form.querySelector('[name="body"]').value;
          var subject = encodeURIComponent('New product review (' + chosen + '/5)');
          var msg = encodeURIComponent(
            'Rating: ' + chosen + '/5\nName: ' + name + '\nEmail: ' + email +
            '\nProduct: ' + document.title + '\nURL: ' + window.location.href + '\n\n' + body
          );
          window.location.href = 'mailto:' + (window.__reviewEmail || '') + '?subject=' + subject + '&body=' + msg;
          form.reset();
          stars.forEach(function (x) { x.classList.remove('is-on'); });
          closeModal();
        });
      }
    }
  }

  /* ----------------------------------------------------------------------
     Wishlist (localStorage)
     ---------------------------------------------------------------------- */
  function bindWishlist() {
    var KEY = 'em-wishlist';
    function read() {
      try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
    }
    function write(v) {
      try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {}
      $$('[data-wishlist-count]').forEach(function (el) { el.textContent = v.length; });
    }
    var items = read();
    write(items);

    $$('[data-wishlist-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      if (items.indexOf(id) > -1) btn.classList.add('is-active');
      btn.addEventListener('click', function () {
        items = read();
        var i = items.indexOf(id);
        if (i > -1) { items.splice(i, 1); btn.classList.remove('is-active'); }
        else { items.push(id); btn.classList.add('is-active'); }
        write(items);
      });
    });
  }

  /* ----------------------------------------------------------------------
     Reveal on scroll
     ---------------------------------------------------------------------- */
  function bindReveal() {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.em-reveal').forEach(function (el) { io.observe(el); });
  }

  /* ----------------------------------------------------------------------
     Scroll to top
     ---------------------------------------------------------------------- */
  function bindScrollTop() {
    var btn = $('[data-scroll-top]');
    if (!btn) return;

    var toggle = function () {
      if (window.pageYOffset > 300) { btn.classList.add('show-scroll'); }
      else { btn.classList.remove('show-scroll'); }
    };

    window.addEventListener('scroll', toggle, { passive: true });
    toggle();

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  /* ----------------------------------------------------------------------
     Boot
     ---------------------------------------------------------------------- */
  function boot() {
    $$('[data-campaign-bar]').forEach(initTicker);
    $$('[data-currency-switcher]').forEach(initCurrency);
    bindPanels();
    bindAccordions();
    bindShowMore();
    $$('[data-gallery]').forEach(initGallery);
    bindLightbox();
    $$('[data-product-section]').forEach(initProductForm);
    bindReviews();
    bindWishlist();
    bindReveal();
    bindScrollTop();
    refreshCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target;
    $$('[data-campaign-bar]', s).forEach(initTicker);
    $$('[data-currency-switcher]', s).forEach(initCurrency);
    $$('[data-gallery]', s).forEach(initGallery);
    $$('[data-product-section]', s).forEach(initProductForm);
    bindAccordions();
    bindShowMore();
    bindReviews();
    bindWishlist();
  });
})();
